import { memo } from 'react';

import { StructuredAnswer, StructuredSurveyTemplate } from '@dreryk/egabinet-survey-frontend-api';

import { Button, StyledFlex } from '@dreryk/react-components';

import { appointmentsTranslationKeys } from '../../../../translations';
import { useMedicalProfileFormContext } from '../../MedicalProfileFormContext';
import { SectionNodeViewModel } from '../../tab/MedicalProfileTab.types';

import { useEntryList } from './EntryList.hooks';
import { EntryListItem } from './EntryListItem';

type EntryListProps = {
   readonly templateCode: string;
   readonly template: StructuredSurveyTemplate;
   readonly initialAnswers: StructuredAnswer[];
   readonly node: SectionNodeViewModel;
};

// TODO DREGAB-29796: entries are not loaded from the survey records and are not saved yet (needs SectionRecordSaveCommand)
export const EntryList = memo(
   (props: EntryListProps): JSX.Element => {
      const { readonly } = useMedicalProfileFormContext();
      const { entryKeys, handleAdd, handleRemove } = useEntryList(props.templateCode, props.node);

      return (
         <StyledFlex direction={'column'} gap={16}>
            {entryKeys.map((entryKey, index) => (
               <EntryListItem
                  key={entryKey}
                  templateCode={props.templateCode}
                  template={props.template}
                  initialAnswers={props.initialAnswers}
                  node={props.node}
                  entryKey={entryKey}
                  position={index + 1}
                  onRemove={handleRemove}
               />
            ))}
            {readonly ? null : (
               <StyledFlex>
                  <Button
                     testId={`entryAdd-${props.node.sectionId}`}
                     label={appointmentsTranslationKeys.medicalProfile.entry.add}
                     type={'button'}
                     onClick={handleAdd}
                  />
               </StyledFlex>
            )}
         </StyledFlex>
      );
   }
);
